export default "__VITE_ASSET__1bcb075c__"